// apps/web/src/components/Security/SecuritySettingsWeb.jsx
import { useSearchParams } from 'react-router-dom';
import useSecurityData from '@mysimpledb/shared/hooks/useSecurityData';
import SecuritySettings from '@mysimpledb/shared/components/Security/SecuritySettings';
import './SecuritySettings.css';

export default function SecuritySettingsWeb({ onSuccess }) {
  /* If this page can do *both* reset (email link) or in-account change,
     look for email+token params. Otherwise, leave email/token null. */
  const [params] = useSearchParams();
  const email = params.get('email'); // null during normal in-account change
  const rToken = params.get('token');

  const token = localStorage.getItem('token'); // for change-password call

  const security = useSecurityData({
    token,
    email,
    resetToken: rToken,
    onSuccess,
  });

  return (
    <SecuritySettings
      state={security}
      handlers={security}
      mode={email ? 'reset' : 'change'}
    />
  );
}
